import React, { Component } from "react";
class RecommendationSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data,
      isAsp: this.props.isAsp !== undefined ? this.props.isAsp : false,
      entityType:
        this.props.entityType !== undefined
          ? this.props.entityType
          : this.props.isAsp !== undefined && this.props.isAsp === true
          ? "asp"
          : "vm",
    };
  }
  render() {
    const { data, recommendationChoiceNum = 0 } = this.props;
    return (
      <div className="table-wrapper" id="ToPDF">
        <div className="table-container">
          <div className="head-titles-resize">
            <div className="title-col-5">Resizing Status:</div>
            <div className="title-col-6">
              {this.props.bvmState}{" "}
              {this.props.bvmState === "OPTIMIZING" ? (
                <i
                  style={{ margin: "auto 14px" }}
                  className="fa fa-info-circle"
                  aria-hidden="true"
                  data-toggle="tooltip"
                  data-placement="left"
                  title={
                    "When manual resizing has been completed, please mark it as complete using Manage " +
                    (this.state.entityType === "db"
                      ? "DBaaS page"
                      : this.state.entityType === "vm"
                      ? "VMs page"
                      : "ASPs page")
                  }
                />
              ) : null}
            </div>
          </div>
          {data.vm.map((key, i) => {
            let sts =
              key.recommendedVMStatus !== null
                ? key.recommendedVMStatus.toLowerCase()
                : "pending";
            return (
              key.recommendationChoiceNum === recommendationChoiceNum && (
                <div className="info-cell">
                  <div className="info-cell-1">
                    <div className="info-graphic-empty">
                      {this.state.entityType === "db" ? (
                        <svg
                          id="vCoreCpuArrows"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 68 68"
                        >
                          <g id="cpu">
                            <path
                              className="cpu-fill"
                              d="M47.8867,59.7266V54.752H44.2959v4.9746H43.05V54.752H39.459v4.9746H38.2139V54.752H34.623v4.9746H33.3848V54.752H29.7866v4.9746H28.5483V54.752H24.95v4.9746H23.7119V54.752H20.1138v4.9746H18.8755V54.752H16.8574a3.61,3.61,0,0,1-3.6015-3.6094V49.125H8.2734V47.8867h4.9825V44.2959H8.2734V43.05h4.9825V39.459H8.2734V38.2139h4.9825V34.623H8.2734V33.3848h4.9825V29.7866H8.2734V28.5483h4.9825V24.95H8.2734V23.7119h4.9825V20.1138H8.2734V18.8755h4.9825V16.8574a3.6057,3.6057,0,0,1,3.6015-3.6015h1.9717V8.2734h1.2461v4.9825h3.59V8.2734h1.2461v4.9825h3.59V8.2734H29.74v4.9825h3.5987V8.2734h1.2382v4.9825h3.5977V8.2734h1.2383v4.9825h3.5986V8.2734H44.25v4.9825h3.59V8.2734h1.2461v4.9825h2.0567a3.61,3.61,0,0,1,3.6094,3.6015v2.0181h4.9746v1.2383H54.752v3.5981h4.9746V24.95H54.752v3.5981h4.9746v1.2383H54.752v3.5982h4.9746V34.623H54.752v3.5909h4.9746V39.459H54.752V43.05h4.9746v1.2461H54.752v3.5908h4.9746V49.125H54.752v2.0176a3.6135,3.6135,0,0,1-3.6094,3.6094H49.125v4.9746ZM20.0972,16.498a3.6035,3.6035,0,0,0-3.5992,3.5992V47.9033A3.6073,3.6073,0,0,0,20.0972,51.51H47.9023A3.6112,3.6112,0,0,0,51.51,47.9033V20.0972a3.6075,3.6075,0,0,0-3.6075-3.5992Z"
                            />
                            <path
                              className="cpu-border"
                              d="M48.7112,8.6486v4.9823h2.4313a3.2341,3.2341,0,0,1,3.2343,3.2266V19.25h4.9746v.4882H54.3768v4.3482h4.9746v.4883H54.3768v4.3482h4.9746v.4883H54.3768V33.76h4.9746v.4883H54.3768v4.34h4.9746v.4961H54.3768v4.34h4.9746v.496H54.3768v4.34h4.9746V48.75H54.3768v2.3929a3.238,3.238,0,0,1-3.2343,3.2343H48.75v4.9746h-.4883V54.3768h-4.34v4.9746h-.496V54.3768h-4.34v4.9746h-.496V54.3768h-4.34v4.9746H33.76V54.3768h-4.348v4.9746h-.4884V54.3768H24.5751v4.9746h-.4883V54.3768H19.7386v4.9746H19.25V54.3768H16.8575a3.2341,3.2341,0,0,1-3.2266-3.2343V48.75H8.6486v-.4883h4.9823v-4.34H8.6486v-.496h4.9823v-4.34H8.6486v-.4961h4.9823v-4.34H8.6486V33.76h4.9823V29.4116H8.6486v-.4883h4.9823V24.5751H8.6486v-.4883h4.9823V19.7386H8.6486V19.25h4.9823V16.8575a3.23,3.23,0,0,1,3.2266-3.2266h2.3468V8.6486H19.7v4.9823h4.34V8.6486h.496v4.9823h4.34V8.6486h.4884v4.9823h4.3481V8.6486h.4883v4.9823H38.55V8.6486h.4884v4.9823h4.3481V8.6486h.4883v4.9823h4.34V8.6486h.4959M20.0971,51.8848H47.9028a3.9865,3.9865,0,0,0,3.982-3.9819V20.0972a3.9826,3.9826,0,0,0-3.982-3.9743H20.0971a3.9787,3.9787,0,0,0-3.9742,3.9743V47.9029a3.9826,3.9826,0,0,0,3.9742,3.9819M49.4612,7.8986H47.4653v4.9823h-2.84V7.8986H42.6365v4.9823H39.7884V7.8986H37.8v4.9823H34.9519V7.8986H32.9636v4.9823H30.1155V7.8986H28.1271v4.9823h-2.84V7.8986h-1.996v4.9823H20.45V7.8986h-1.996v4.9823H16.8575a3.9774,3.9774,0,0,0-3.9766,3.9766V18.5H7.8986v1.9882h4.9823v2.8482H7.8986v1.9883h4.9823v2.8482H7.8986v1.9883h4.9823V33.01H7.8986V34.998h4.9823v2.84H7.8986v1.9961h4.9823v2.84H7.8986v1.996h4.9823v2.84H7.8986V49.5h4.9823v1.6429a3.979,3.979,0,0,0,3.9766,3.9843H18.5v4.9746h1.9882V55.1268h2.8482v4.9746h1.9883V55.1268h2.8481v4.9746h1.9884V55.1268H33.01v4.9746H34.998V55.1268h2.84v4.9746h1.996V55.1268h2.84v4.9746h1.996V55.1268h2.84v4.9746H49.5V55.1268h1.6429a3.9807,3.9807,0,0,0,3.9843-3.9843V49.5h4.9746V47.5113H55.1268v-2.84h4.9746v-1.996H55.1268v-2.84h4.9746V37.8384H55.1268v-2.84h4.9746V33.01H55.1268V30.1616h4.9746V28.1733H55.1268V25.3251h4.9746V23.3368H55.1268V20.4886h4.9746V18.5H55.1268V16.8575a3.979,3.979,0,0,0-3.9843-3.9766H49.4612V7.8986ZM20.0971,51.1348a3.23,3.23,0,0,1-3.2242-3.2319V20.0972a3.2238,3.2238,0,0,1,3.2242-3.2243H47.9028a3.23,3.23,0,0,1,3.232,3.2243V47.9029a3.237,3.237,0,0,1-3.232,3.2319Z"
                            />
                          </g>
                          <path
                            className="mem-border"
                            d="M48.3021,20.9724H44.5173a1.5277,1.5277,0,1,1-3.0554,0H26.0237a1.5316,1.5316,0,1,1-3.0631,0h-3.255a1.0368,1.0368,0,0,0-1.0363,1.0363V41.032a1.03,1.03,0,0,0,1.0363,1.0287h1.3435v4.967h1.0824V43.243h1.3819v3.7847h1.3895V43.243h1.39v3.7847h1.3895V43.243h1.3818v3.7847h1.3895V43.243h1.39v3.7847h1.39V43.243h1.3895v3.7847h1.3819V43.243h1.3895v3.7847h1.3895V43.243h1.3895v3.7847h1.3819V43.243h1.3894v3.7847h1.39V43.243h1.3895v3.7847h1.2283v-4.967h1.3512a1.0287,1.0287,0,0,0,1.0286-1.0287V22.0087A1.0352,1.0352,0,0,0,48.3021,20.9724ZM29.01,38.7673a.6324.6324,0,0,1-.63.63H21.7093a.6258.6258,0,0,1-.6218-.63V26.8682a.6192.6192,0,0,1,.6218-.6219h6.6712a.6258.6258,0,0,1,.63.6219V38.7673Zm8.9743,0a.6324.6324,0,0,1-.63.63H30.6836a.6324.6324,0,0,1-.63-.63V26.8682a.6258.6258,0,0,1,.63-.6219h6.6712a.6258.6258,0,0,1,.63.6219V38.7673Zm8.9666,0a.6258.6258,0,0,1-.6218.63H39.6578a.6324.6324,0,0,1-.6294-.63V26.8682a.6258.6258,0,0,1,.6294-.6219h6.6713a.6192.6192,0,0,1,.6218.6219V38.7673Z"
                          />
                          <rect className="bondingBox" width="68" height="68" />
                        </svg>
                      ) : (
                        <svg
                          id="cupIconValidation"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 68 68"
                        >
                          <g>
                            <path
                              className="cpuIconPart2"
                              d="M46.76,57.94V53.35H43.14v4.59H42.3V53.35H38.68v4.59h-.84V53.35H34.22v4.59h-.83V53.35H29.76v4.59h-.83V53.35H25.31v4.59h-.84V53.35H20.85v4.59H20V53.35H18a3.17,3.17,0,0,1-3.17-3.17v-2H10.24v-.84h4.59V43.71H10.24v-.83h4.59V39.25H10.24v-.83h4.59V34.79H10.24V34h4.59V30.34H10.24V29.5h4.59V25.88H10.24V25h4.59V21.42H10.24v-.83h4.59v-2A3.17,3.17,0,0,1,18,15.4h2V10.81h.84V15.4h3.62V10.81h.84V15.4h3.62V10.81h.83V15.4h3.63V10.81h.83V15.4H37.8V10.81h.84V15.4h3.62V10.81h.84V15.4h3.62V10.81h.83V15.4h2.06a3.18,3.18,0,0,1,3.17,3.17v2h4.59v.83H52.78V25h4.59v.84H52.78V29.5h4.59v.84H52.78V34h4.59v.83H52.78v3.63h4.59v.83H52.78v3.63h4.59v.83H52.78v3.62h4.59v.84H52.78v2a3.18,3.18,0,0,1-3.17,3.17h-2v4.59ZM24,21.78a2.79,2.79,0,0,0-2.78,2.78V44.19A2.79,2.79,0,0,0,24,47H43.62a2.79,2.79,0,0,0,2.78-2.78V24.56a2.79,2.79,0,0,0-2.78-2.78Z"
                            />
                            <path
                              className="cpuIconPart1"
                              d="M49.61,15.9a2.68,2.68,0,0,1,2.67,2.67V50.18a2.68,2.68,0,0,1-2.67,2.67H18a2.68,2.68,0,0,1-2.67-2.67V18.57A2.68,2.68,0,0,1,18,15.9H49.61M24,47.47H43.62a3.28,3.28,0,0,0,3.28-3.28V24.56a3.28,3.28,0,0,0-3.28-3.28H24a3.28,3.28,0,0,0-3.28,3.28V44.19A3.28,3.28,0,0,0,24,47.47M48.05,10.31H46.22V14.9H43.6V10.31H41.76V14.9H39.14V10.31H37.3V14.9H34.68V10.31H32.85V14.9H30.22V10.31H28.39V14.9H25.77V10.31H23.93V14.9H21.31V10.31H19.47V14.9H18a3.67,3.67,0,0,0-3.67,3.67v1.52H9.74v1.83h4.59v2.62H9.74v1.84h4.59V29H9.74v1.84h4.59v2.62H9.74v1.83h4.59v2.63H9.74v1.83h4.59v2.62H9.74v1.84h4.59v2.62H9.74v1.84h4.59v1.51A3.67,3.67,0,0,0,18,53.85h1.51v4.59h1.84V53.85H24v4.59h1.84V53.85h2.62v4.59h1.83V53.85h2.63v4.59h1.83V53.85h2.62v4.59h1.84V53.85H41.8v4.59h1.84V53.85h2.62v4.59h1.83V53.85h1.52a3.67,3.67,0,0,0,3.67-3.67V48.67h4.59V46.83H53.28V44.21h4.59V42.37H53.28V39.75h4.59V37.92H53.28V35.29h4.59V33.46H53.28V30.84h4.59V29H53.28V26.38h4.59V24.54H53.28V21.92h4.59V20.09H53.28V18.57a3.68,3.68,0,0,0-3.67-3.67H48.05V10.31ZM24,46.47a2.28,2.28,0,0,1-2.28-2.28V24.56A2.28,2.28,0,0,1,24,22.28H43.62a2.28,2.28,0,0,1,2.28,2.28V44.19a2.28,2.28,0,0,1-2.28,2.28Z"
                            />
                          </g>
                          <rect className="bondingBox" width="68" height="68" />
                        </svg>
                      )}
                    </div>
                  </div>
                  <div className="info-cell-2 text-style">
                    {this.state.entityType === "db" ? "vCore" : "CPU"}
                  </div>
                  <div className="info-cell-5">
                    <div className={"resize-state-icon-cont " + sts}></div>
                  </div>
                  <div className="info-cell-6">
                    <div className="resize-state-text-cont">
                      {sts.toUpperCase()}
                    </div>
                  </div>
                </div>
              )
            );
          })}
          {this.state.entityType === "db"
            ? data.osdisk.map((key, i) => {
                let sts =
                  key.recommendedOSDiskStatus !== null
                    ? key.recommendedOSDiskStatus.toLowerCase()
                    : "pending";
                return (
                  key.recommendationChoiceNum === recommendationChoiceNum && (
                    <div className="info-cell">
                      <div className="info-cell-1">
                        <div className="info-graphic-empty">
                          <svg
                            id="vCoreMemoryArrows"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 68 68"
                          >
                            <rect
                              className="bondingBox"
                              width="68"
                              height="68"
                            />
                            <g className="growing">
                              <path
                                className="vCore-mem-icon"
                                d="M48.3021,20.9724H44.5173a1.5277,1.5277,0,1,1-3.0554,0H26.0237a1.5316,1.5316,0,1,1-3.0631,0h-3.255a1.0368,1.0368,0,0,0-1.0363,1.0363V41.032a1.03,1.03,0,0,0,1.0363,1.0287h1.3435v4.967h1.0824V43.243h1.3819v3.7847h1.3895V43.243h1.39v3.7847h1.3895V43.243h1.3818v3.7847h1.3895V43.243h1.39v3.7847h1.39V43.243h1.3895v3.7847h1.3819V43.243h1.3895v3.7847h1.3895V43.243h1.3895v3.7847h1.3819V43.243h1.3894v3.7847h1.39V43.243h1.3895v3.7847h1.2283v-4.967h1.3512a1.0287,1.0287,0,0,0,1.0286-1.0287V22.0087A1.0352,1.0352,0,0,0,48.3021,20.9724ZM29.01,38.7673a.6324.6324,0,0,1-.63.63H21.7093a.6258.6258,0,0,1-.6218-.63V26.8682a.6192.6192,0,0,1,.6218-.6219h6.6712a.6258.6258,0,0,1,.63.6219V38.7673Zm8.9743,0a.6324.6324,0,0,1-.63.63H30.6836a.6324.6324,0,0,1-.63-.63V26.8682a.6258.6258,0,0,1,.63-.6219h6.6712a.6258.6258,0,0,1,.63.6219V38.7673Zm8.9666,0a.6258.6258,0,0,1-.6218.63H39.6578a.6324.6324,0,0,1-.6294-.63V26.8682a.6258.6258,0,0,1,.6294-.6219h6.6713a.6192.6192,0,0,1,.6218.6219V38.7673Z"
                              />
                              <path
                                className="cpu-fill"
                                d="M60.1014,20.4886V18.5H55.1268V16.8575a3.979,3.979,0,0,0-3.9843-3.9766H49.4612V7.8986H47.4653v4.9823h-2.84V7.8986H42.6365v4.9823H39.7884V7.8986H37.8v4.9823H34.9519V7.8986H32.9636v4.9823H30.1155V7.8986H28.1271v4.9823h-2.84V7.8986h-1.996v4.9823H20.45V7.8986h-1.996v4.9823H16.8575a3.9774,3.9774,0,0,0-3.9766,3.9766V18.5H7.8986v1.9882h4.9823v2.8482H7.8986v1.9883h4.9823v2.8482H7.8986v1.9883h4.9823V33.01H7.8986V34.998h4.9823v2.84H7.8986v1.9961h4.9823v2.84H7.8986v1.996h4.9823v2.84H7.8986V49.5h4.9823v1.6429a3.979,3.979,0,0,0,3.9766,3.9843H18.5v4.9746h1.9882V55.1268h2.8482v4.9746h1.9883V55.1268h2.8481v4.9746h1.9884V55.1268H33.01v4.9746H34.998V55.1268h2.84v4.9746h1.996V55.1268h2.84v4.9746h1.996V55.1268h2.84v4.9746H49.5V55.1268h1.6429a3.9807,3.9807,0,0,0,3.9843-3.9843V49.5h4.9746V47.5114H55.1268v-2.84h4.9746v-1.996H55.1268v-2.84h4.9746V37.8384H55.1268v-2.84h4.9746V33.01H55.1268V30.1616h4.9746V28.1733H55.1268V25.3251h4.9746V23.3368H55.1268V20.4886ZM51.1348,47.9029a3.237,3.237,0,0,1-3.232,3.2319H20.0971a3.23,3.23,0,0,1-3.2242-3.2319V20.0972a3.2238,3.2238,0,0,1,3.2242-3.2243H47.9028a3.23,3.23,0,0,1,3.232,3.2243V47.9029Z"
                              />
                            </g>
                          </svg>
                        </div>
                      </div>
                      <div className="info-cell-2 text-style">vCore MEMORY</div>
                      <div className="info-cell-5">
                        <div className={"resize-state-icon-cont " + sts}></div>
                      </div>
                      <div className="info-cell-6">
                        <div className="resize-state-text-cont">
                          {sts.toUpperCase()}
                        </div>
                      </div>
                    </div>
                  )
                );
              })
            : null}
          {data.vm.map((key, i) => {
            let sts =
              key.recommendedVMStatus !== null
                ? key.recommendedVMStatus.toLowerCase()
                : "pending";
            return (
              key.recommendationChoiceNum === recommendationChoiceNum && (
                <div className="info-cell">
                  <div className="info-cell-1">
                    <div className="info-graphic-empty">
                      {this.state.entityType === "db" ? (
                        <svg
                          id="DataDiskGray"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 68 68"
                        >
                          <rect className="bondingBox" width="68" height="68" />
                          <path
                            className="data-disk"
                            d="M51.9435,24.3661a1.0087,1.0087,0,0,0,.6357-.9535V12.8252A2.8245,2.8245,0,0,0,49.754,10H18.246a2.8245,2.8245,0,0,0-2.8252,2.8252V23.4126a1.0087,1.0087,0,0,0,.6357.9535,1.7684,1.7684,0,0,1,1.13,1.6174v.0283a1.7735,1.7735,0,0,1-1.13,1.6527,1.0062,1.0062,0,0,0-.6357.9465V39.4032a1.0132,1.0132,0,0,0,.6357.9464,1.7684,1.7684,0,0,1,0,3.2984,1.0064,1.0064,0,0,0-.6357.9465v10.58A2.8244,2.8244,0,0,0,18.246,58H49.754a2.8244,2.8244,0,0,0,2.8252-2.8252v-10.58a1.0064,1.0064,0,0,0-.6357-.9465,1.7684,1.7684,0,0,1,0-3.2984,1.0132,1.0132,0,0,0,.6357-.9464V28.611a1.0062,1.0062,0,0,0-.6357-.9465,1.7634,1.7634,0,0,1-1.13-1.6527v-.0283A1.7582,1.7582,0,0,1,51.9435,24.3661ZM45.5021,50.817a1.94,1.94,0,0,1-.36.3178q-2.13,1.462-4.2732,2.917a7.23,7.23,0,0,1-.7062.3461,2.811,2.811,0,0,1-.3956-.4732q-1.6527-3.5916-3.32-7.1972c-.9182-1.9988-1.8363-4.0118-2.7687-6.0035-.1271-.2684-.1412-.5086.0566-.6781a4.0741,4.0741,0,0,1,.9676-.65.6753.6753,0,0,1,.5721.17q4.492,4.63,8.9629,9.2737c.41.4238.8052.8546,1.229,1.2572a.7535.7535,0,0,1,.0847.0707A.4665.4665,0,0,1,45.5021,50.817Zm1.8434-16.146a13.3411,13.3411,0,0,1-4.9723,8.9276l-.1978.2966-.3037-.2754c-.3108-.29-.6215-.565-.9323-.8476-.7628-.6851-1.4832-1.3349-2.19-2.02-.4449-.4308-.8687-.8829-1.2925-1.3349-.3531-.3814-.7133-.7628-1.0877-1.13a2.0209,2.0209,0,0,0-2.2531-.4521A2.8488,2.8488,0,0,0,31.9694,40.18a2.5654,2.5654,0,0,0,.2119,1.2007c.4591,1.0524.9535,2.1189,1.4338,3.143.2048.438.41.8759.6074,1.3067a2.1585,2.1585,0,0,1,.0918.2825l.0918.4308h-.445A13.4319,13.4319,0,1,1,47.4373,33.1313,12.5043,12.5043,0,0,1,47.3455,34.671Z"
                          />
                          <circle
                            className="diskCenter"
                            cx="34"
                            cy="33.1313"
                            r="2.8663"
                          />
                        </svg>
                      ) : (
                        <svg
                          id="memoryIconAnalysis"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 72 68"
                        >
                          <rect className="bondingBox" width="68" height="68" />
                          <path
                            className="memoryIcon"
                            d="M62.5,9.9h-7a2.9,2.9,0,0,1-5.7,0H21.2a2.8,2.8,0,1,1-5.6,0H9.5a2,2,0,0,0-1.9,1.9V47a1.9,1.9,0,0,0,1.9,1.9H12v9.2h2v-7h2.6v7h2.6v-7h2.5v7h2.6v-7h2.6v7h2.5v-7H32v7h2.6v-7h2.5v7h2.6v-7h2.6v7h2.5v-7h2.6v7H50v-7h2.5v7h2.6v-7h2.6v7H60V48.9h2.5A1.9,1.9,0,0,0,64.4,47V11.8A2,2,0,0,0,62.5,9.9Zm-35.8,33a1,1,0,0,1-1,1.1H13.1a1,1,0,0,1-1-1.1V24.7a1,1,0,0,1,1-1.1H25.7a1,1,0,0,1,1,1.1Zm16.6,0a1,1,0,0,1-1,1.1H29.7a1,1,0,0,1-1-1.1V24.7a1,1,0,0,1,1-1.1H42.3a1,1,0,0,1,1,1.1Zm16.6,0a1,1,0,0,1-1,1.1H46.3a1,1,0,0,1-1-1.1V24.7a1,1,0,0,1,1-1.1H58.9a1,1,0,0,1,1,1.1Z"
                          />
                        </svg>
                      )}
                    </div>
                  </div>
                  <div className="info-cell-2 text-style">
                    {this.state.entityType === "db" ? "DATA DISK" : "MEMORY"}
                  </div>
                  <div className="info-cell-5">
                    <div className={"resize-state-icon-cont " + sts}></div>
                  </div>
                  <div className="info-cell-6">
                    <div className="resize-state-text-cont">
                      {sts.toUpperCase()}
                    </div>
                  </div>
                </div>
              )
            );
          })}
          {data.vm.map((key, i) => {
            let sts =
              key.recommendedVMStatus !== null
                ? key.recommendedVMStatus.toLowerCase()
                : "pending";
            return (
              key.recommendationChoiceNum === recommendationChoiceNum && (
                <div className="info-cell">
                  <div className="info-cell-1">
                    <div className="info-graphic-empty">
                      {this.state.entityType === "db" ? (
                        <svg
                          id="LogDiskGray"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 68 68"
                        >
                          <rect className="bondingBox" width="68" height="68" />
                          <path
                            className="log-disk"
                            d="M45.8659,31.607a12.0536,12.0536,0,0,0-.7412-2.0894,12.5492,12.5492,0,0,0-1.5035-2.4494,12.2636,12.2636,0,0,0-.9389-1.0588A12.5463,12.5463,0,0,0,39.88,23.92a12.3585,12.3585,0,0,0-5.8941-1.5036,12.1165,12.1165,0,0,0-3.7624.6,12.5915,12.5915,0,0,0-2.0964.9035,11.7185,11.7185,0,0,0-2.7883,2.0894,12.1092,12.1092,0,0,0-2.2447,3.0847c-.0706.1412-.1411.2823-.2047.4235A12.1245,12.1245,0,0,0,21.76,34c-.0212.367-.0212.7412-.007,1.1153a11.6747,11.6747,0,0,0,.2682,2.0894,10.861,10.861,0,0,0,.3247,1.2282,12.4643,12.4643,0,0,0,1.0024,2.28,11.9209,11.9209,0,0,0,1.4894,2.0894,12.2009,12.2009,0,0,0,9.127,4.1083h.5859l-.127-.5718a1.4533,1.4533,0,0,0-.0918-.2824c-.1695-.3882-.353-.7835-.5436-1.1717C33.3577,43.96,32.913,43,32.4965,42.047a2.1237,2.1237,0,0,1-.1836-1.0023,2.3844,2.3844,0,0,1,1.7859-1.9694l.0635-.0212a1.6458,1.6458,0,0,1,1.8636.3741c.3388.3318.6564.6706.9812,1.0165.3741.3953.7623.8117,1.1647,1.2.6423.6212,1.2917,1.207,1.9765,1.8282.2823.2471.5646.5012.84.7624l.374.3317.2754-.3529a12.399,12.399,0,0,0,1.5035-1.4118,12.1894,12.1894,0,0,0,2.8376-5.5976c.0777-.3671.1412-.7412.1835-1.1224.0354-.3247.0636-.6494.0707-.967a9.8331,9.8331,0,0,0,0-1.1153A11.8933,11.8933,0,0,0,45.8659,31.607Z"
                          />
                          <path
                            className="log-file"
                            d="M43.4941,20.1929h-.007a2.3217,2.3217,0,0,1-2.3083-2.0259,2.0957,2.0957,0,0,1-.0211-.2965V10H18.4988a1.8452,1.8452,0,0,0-1.8494,1.8423V56.1435A1.8528,1.8528,0,0,0,18.4988,58H49.5012a1.8528,1.8528,0,0,0,1.8494-1.8565V20.1859ZM19.8329,18.3223H39.9506v2.0894H19.8329Zm24.5224,32.28a1.4193,1.4193,0,0,1-.3247.2894q-1.9166,1.3236-3.8471,2.6259a5.9274,5.9274,0,0,1-.6353.3177,2.5474,2.5474,0,0,1-.3529-.4306c-.9953-2.16-1.9976-4.313-2.993-6.48-.8258-1.8071-1.6517-3.6142-2.4917-5.4071-.1129-.247-.1341-.4658.0494-.6141a3.87,3.87,0,0,1,.8753-.5859.6436.6436,0,0,1,.5153.1482q4.0341,4.1825,8.0753,8.3648c.3671.3741.72.7623,1.1082,1.1223a.57.57,0,0,1,.0635.0706A.4.4,0,0,1,44.3553,50.6023Zm3.3106-24.5929H42.6824a12.2476,12.2476,0,0,1,.9388,1.0588,12.5463,12.5463,0,0,1,1.5035,2.4494h2.5412v2.0895h-1.8A11.8913,11.8913,0,0,1,46.233,34a9.8313,9.8313,0,0,1,0,1.1152h1.4329v2.09H45.9788a11.79,11.79,0,0,1-1.3341,3.5082h2.9436v2.0894H43.1412a12.393,12.393,0,0,1-1.5036,1.4118l-.2752.3529-.3741-.3317c-.2753-.2612-.5577-.5153-.84-.7624-.6848-.6212-1.3342-1.207-1.9765-1.8282-.4024-.3883-.7906-.8047-1.1647-1.2-.3247-.3459-.6424-.6848-.9812-1.0165a1.6457,1.6457,0,0,0-1.8635-.3741l-.0636.0212a2.3844,2.3844,0,0,0-1.7859,1.9694,2.1224,2.1224,0,0,0,.1836,1.0023c.4165.953.8612,1.913,1.2918,2.8377.1905.3882.3741.7835.5435,1.1717a1.4555,1.4555,0,0,1,.0918.2824l.127.5718h-.5859a12.2012,12.2012,0,0,1-9.1271-4.1083H19.8329V40.7129h3.5154a12.4711,12.4711,0,0,1-1.0024-2.28,10.8455,10.8455,0,0,1-.3247-1.2282H19.8329v-2.09h1.92c-.0141-.3741-.0141-.7482.0071-1.1152a11.98,11.98,0,0,1,.3741-2.3929H19.8329V29.5176h3.0565c.0635-.1412.1342-.2823.2047-.4235a12.1092,12.1092,0,0,1,2.2447-3.0847H19.8329V23.92h8.2942a12.5807,12.5807,0,0,1,2.0965-.9035,12.1157,12.1157,0,0,1,3.7622-.6A12.3589,12.3589,0,0,1,39.88,23.92h7.7859Zm-4.1788-7.6871h6.5435L43.0283,11.32v6.5505a.451.451,0,0,0,.1411.3248A.446.446,0,0,0,43.4871,18.3223Z"
                          />
                          <path
                            className="diskCenter"
                            d="M33.9859,32.1082a2.5607,2.5607,0,0,0-2.5553,2.5624,2.2665,2.2665,0,0,0,.0423.4447,2.5474,2.5474,0,0,0,2.153,2.0894h.72a2.54,2.54,0,0,0,2.16-2.0894,2.2665,2.2665,0,0,0,.0423-.4447A2.5622,2.5622,0,0,0,33.9859,32.1082Z"
                          />
                        </svg>
                      ) : (
                        <svg
                          id="networkArrowIconRecom"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 68 68"
                        >
                          <path
                            className="networkIcon"
                            d="M58.9,41H54.6V33.5a1.8,1.8,0,0,0-2-1.7H35.9V27h4.3a1.9,1.9,0,0,0,1.9-1.6V12.1A1.9,1.9,0,0,0,40.6,10H27.1a2,2,0,0,0-1.2,1.8V25h0a1.9,1.9,0,0,0,1.8,2h4.4v4.7H15.3a1.9,1.9,0,0,0-1.9,1.7c0,.1-.1.3,0,.5V41H9.2c-1.1,0-2.1.5-2.1,1.6V56.4a.3.3,0,0,0,.1.2A1.7,1.7,0,0,0,9,58H21.5a1.9,1.9,0,0,0,1.9-1.8v-13a3,3,0,0,0-.2-1A1.7,1.7,0,0,0,21.4,41H17.1V35.7h15V41H27.6a1.9,1.9,0,0,0-1.7,2.1V56.2a1.9,1.9,0,0,0,2,1.8H40.4a1.9,1.9,0,0,0,1.7-2.1V42.8a1.8,1.8,0,0,0-2-1.8H35.9V35.7h15v5a.3.3,0,0,1-.3.3H46.5a2,2,0,0,0-1.9,2.1c.1,4.3.1,8.5,0,12.8v.2a2.2,2.2,0,0,0,2.1,2H58.9a1.9,1.9,0,0,0,2-1.6V42.8A2,2,0,0,0,58.9,41ZM18.7,46.5v6H11.8v-6Zm18.7,0v6H30.6v-6ZM30.6,21.6v-6h6.8v6ZM55.9,52.5H49.1v-6h6.8Z"
                          />
                          <rect className="bondingBox" width="68" height="68" />
                        </svg>
                      )}
                    </div>
                  </div>
                  <div className="info-cell-2 text-style">
                    {this.state.entityType === "db" ? "LOG DISK" : "NETWORK"}
                  </div>
                  <div className="info-cell-5">
                    <div className={"resize-state-icon-cont " + sts}></div>
                  </div>
                  <div className="info-cell-6">
                    <div className="resize-state-text-cont">
                      {sts.toUpperCase()}
                    </div>
                  </div>
                </div>
              )
            );
          })}
          {this.state.entityType !== "db"
            ? data.osdisk.map((key, i) => {
                let sts =
                  key.recommendedOSDiskStatus !== null
                    ? key.recommendedOSDiskStatus.toLowerCase()
                    : "pending";
                return (
                  key.recommendationChoiceNum === recommendationChoiceNum && (
                    <div className="info-cell">
                      <div className="info-cell-1">
                        <div className="info-graphic-empty">
                          <div className="disk-validation-svg">
                            <svg
                              id="osDiskIconRecom"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 39 68"
                            >
                              <defs> </defs>
                              <path
                                className="osDiskIcon"
                                d="M38,58.29H1.34A1.48,1.48,0,0,1,.41,58,1.47,1.47,0,0,1,0,57.09c0-5.55,0-45.8,0-45.8,0-.87.34-1.2,1.22-1.2H38ZM27.84,39.87A14.23,14.23,0,1,0,19,43a1.42,1.42,0,0,0-.07-.22c-.75-1.62-1.52-3.23-2.23-4.86a3.18,3.18,0,0,1-.26-1.52A3.47,3.47,0,0,1,19,33.51a2.58,2.58,0,0,1,2.88.57c.88.88,4.81,4.73,6,5.8Zm-2.13,12a7.85,7.85,0,0,0,.77-.38c1.56-1.05,4.93-3.39,5-3.52a.49.49,0,0,0,.06-.7L20.39,35.75a.7.7,0,0,0-.62-.18,4.64,4.64,0,0,0-1.06.7.58.58,0,0,0-.06.74c1,2.17,5.43,11.76,6.63,14.37A3.13,3.13,0,0,0,25.71,51.9ZM9,52.72a2.88,2.88,0,0,0-2.82-2.94H6.1a2.89,2.89,0,0,0,0,5.77A2.88,2.88,0,0,0,9,52.71Z"
                                transform="translate(0.5)"
                              />
                              <circle
                                className="diskCenter"
                                cx="19.5"
                                cy="28.74"
                                r="3.08"
                              />
                              <rect
                                className="bondingBox"
                                x="0.5"
                                width="38"
                                height="68"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div className="info-cell-2 text-style">OS Disk</div>
                      <div className="info-cell-5">
                        <div className={"resize-state-icon-cont " + sts}></div>
                      </div>
                      <div className="info-cell-6">
                        <div className="resize-state-text-cont">
                          {sts.toUpperCase()}
                        </div>
                      </div>
                    </div>
                  )
                );
              })
            : null}

          {this.state.entityType !== "db"
            ? Object.keys(data.dataDisk).map((key) => {
                return (
                  data.dataDisk[key]
                    .filter(
                      (value) =>
                        value.recommendationChoiceNum === recommendationChoiceNum
                    )
                    .map((value, i) => {
                    let sts =
                      value.recommendedDataDiskStatus !== null
                        ? value.recommendedDataDiskStatus.toLowerCase()
                        : "pending";
                    return (
                      <div className="info-cell">
                        <div className="info-cell-1">
                          <div className="info-graphic-empty">
                            <div className="disk-validation-svg">
                              <svg
                                id="osDiskIconRecom"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 39 68"
                              >
                                <defs> </defs>
                                <path
                                  className="osDiskIcon"
                                  d="M38,58.29H1.34A1.48,1.48,0,0,1,.41,58,1.47,1.47,0,0,1,0,57.09c0-5.55,0-45.8,0-45.8,0-.87.34-1.2,1.22-1.2H38ZM27.84,39.87A14.23,14.23,0,1,0,19,43a1.42,1.42,0,0,0-.07-.22c-.75-1.62-1.52-3.23-2.23-4.86a3.18,3.18,0,0,1-.26-1.52A3.47,3.47,0,0,1,19,33.51a2.58,2.58,0,0,1,2.88.57c.88.88,4.81,4.73,6,5.8Zm-2.13,12a7.85,7.85,0,0,0,.77-.38c1.56-1.05,4.93-3.39,5-3.52a.49.49,0,0,0,.06-.7L20.39,35.75a.7.7,0,0,0-.62-.18,4.64,4.64,0,0,0-1.06.7.58.58,0,0,0-.06.74c1,2.17,5.43,11.76,6.63,14.37A3.13,3.13,0,0,0,25.71,51.9ZM9,52.72a2.88,2.88,0,0,0-2.82-2.94H6.1a2.89,2.89,0,0,0,0,5.77A2.88,2.88,0,0,0,9,52.71Z"
                                  transform="translate(0.5)"
                                />
                                <circle
                                  className="diskCenter"
                                  cx="19.5"
                                  cy="28.74"
                                  r="3.08"
                                />
                                <rect
                                  className="bondingBox"
                                  x="0.5"
                                  width="38"
                                  height="68"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div className="info-cell-2 text-style">Disk {key}</div>
                        <div className="info-cell-5">
                          <div
                            className={"resize-state-icon-cont " + sts}
                          ></div>
                        </div>
                        <div className="info-cell-6">
                          <div className="resize-state-text-cont">
                            {sts.toUpperCase()}
                          </div>
                        </div>
                      </div>
                    );
                  })
                );
              })
            : null}
        </div>
      </div>
    );
  }
}
export default RecommendationSummary;
